import css from './logo.module.css'
const Logo = ({ animated = false }: { animated?: boolean }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      preserveAspectRatio="xMinYMin meet"
      viewBox="0 0 346 50"
      className={[
        { cls: css.logo, add: true },
        { cls: css.animated, add: animated },
      ]
        .filter(({ add }) => add)
        .map(({ cls }) => cls)
        .join(' ')}
    >
      <path
        fill="#FEFEFE"
        fillRule="evenodd"
        d="M345.5 0h-39a.5.5 0 0 0-.5.5v4a.5.5 0 0 0 .5.4h17v44.6c0 .3.2.5.4.5h4.2c.2 0 .4-.2.4-.5V5h17a.5.5 0 0 0 .5-.5v-4a.5.5 0 0 0-.5-.4M288 .5a.5.5 0 0 0-.5-.5h-4a.5.5 0 0 0-.5.5v49c0 .3.2.5.5.5h4a.5.5 0 0 0 .5-.5V.5zM241.8 45H226V4.9h15.8c8.3 0 15.2 9 15.2 19.2 0 5-1 21-15.2 21m0-45.1h-20.5s-.3 0-.3.4v49.1c0 .4.2.5.5.5H242c12.4 0 20.1-9.9 20.1-25.9 0-13-9-24.1-20.1-24.1m-46.4 0h-4.2a.5.5 0 0 0-.4.5v41L166.2.2a.5.5 0 0 0-.2-.2h-7.8s-.2 0-.2.3v49.2c0 .3.2.5.5.5h4a.5.5 0 0 0 .6-.5V4.6L190 50h5.7c.3 0 .3-.2.3-.2V.5a.5.5 0 0 0-.5-.5m-69.8.1V0h-7.3a.1.1 0 0 0-.1.1L105 49.8s0 .1.1.1h4.8l.2-.1L122 5.1l12 44.8v.1h4.9c.1 0 0-.2 0-.2L125.8.1zm-38.2 45h-19C61.9 45 55 38.8 55 25S63 4.8 68.6 4.8h18.7a.5.5 0 0 0 .5-.4v-4a.5.5 0 0 0-.5-.5H68.6C60.9 0 50 7.8 50 25s9.3 25 18.6 25h18.9c.3 0 .5-.2.5-.5v-4a.5.5 0 0 0-.5-.4m-64-22.7H14c-5.5 0-9-5.2-9-8.7C5 10 7.8 5 14 5h20.3a.5.5 0 0 0 .5-.4V.5a.5.5 0 0 0-.5-.5H14C5.2 0 0 7 0 13.7c0 6.5 5.8 13.7 14 13.7h9.5c5.5 0 8.5 5.1 8.5 8.7 0 3.5-2.2 9-8.5 9H1.6a.5.5 0 0 0-.4.4v4c0 .3.2.5.4.5h21.9C32.3 50 37 42.7 37 36c0-3-1.3-6.4-3.5-9a13 13 0 0 0-10-4.6"
      />
    </svg>
  )
}

export default Logo
